/**
 * Pure enums, types, and utilities for the AI panel.
 * No React / 'use client' dependency — safe to import from server components.
 */

export enum AIPanelInitialState {
  Collapsed = 'collapsed',
  Expanded = 'expanded',
}

export const DEFAULT_PAGE_KEY = '__default__';

export enum AIPanelPage {
  Learn = 'learn',
  Dashboard = 'dashboard',
  Search = 'search',
  Answers = 'answers',
  Library = 'library',
  Video = 'video',
  Library_LoggedOut = 'library_logged_out',
  OsmosisAI = 'osmosisAI',
  Default = DEFAULT_PAGE_KEY,
}

export type AIPanelOptions = {
  identifier: AIPanelPage | string;
  mobile: { initialState: AIPanelInitialState };
  desktop: { initialState: AIPanelInitialState };
};

type InitialStateOptions = {
  mobile?: AIPanelInitialState;
  desktop?: AIPanelInitialState;
};

/**
 * Builds an AIPanelOptions object for a given page identifier.
 * Defaults: mobile → collapsed, desktop → expanded.
 */
export function getPanelOptions(
  identifier: AIPanelPage | string,
  options?: InitialStateOptions,
): AIPanelOptions {
  return {
    identifier,
    mobile: {
      initialState: options?.mobile ?? AIPanelInitialState.Collapsed,
    },
    desktop: {
      initialState: options?.desktop ?? AIPanelInitialState.Expanded,
    },
  };
}
